// TSS vite/03 §"Query keys convention".
// Tuples, entity name first, scope narrowing rightward.
//
// The list key carries the filters, so switching client or state is a
// different key and not a refetch that throws away the previous answer.

export const projectKeys = {
    all:    ['projects'],
    list:   (params) => ['projects', 'list', params],
    detail: (id)     => ['projects', 'detail', id],
    teams:  (id)     => ['projects', 'detail', id, 'teams'],
};
